export default __webpack_public_path__ + "static/media/DSC_0527.ec205278.jpg";